<template>
	<div :class="[$store.state.layout_style, $store.state.menu_style]">
		<component v-bind:is="layout"></component>
	</div>
</template>
<script>
export default {
	metaInfo: {
		title: 'Sistema CPV',
		titleTemplate: '%s | Sistema CPV',
	},
	components: {
		app: () => import('./layouts/app-layout.vue'),
		auth: () => import('./layouts/auth-layout.vue'),
		landing: () => import('./layouts/landing-layout.vue')
	},
	computed: {
		layout() {
			const availableLayouts = ['app', 'auth', 'landing'];
			return availableLayouts.includes(this.$store.getters.layout)
				? this.$store.getters.layout
				: 'app'
		},
	},
	methods: {},
};
</script>
